export const accessToken = '';
export const scopes = '';

// prettier-ignore
type CI_ENVIRONMENT_NAMES =
    'eon-hems-dev' |
    'eon-hems-feature-1' |
    'eon-hems-feature-2' |
    'eon-hems-qa' |
    'eon-hems-qa-1' |
    'eon-hems-qa-2' |
    'eon-hems-prod' |
    'eon-hems-prod-2';

// prettier-ignore
export const CI_ENVIRONMENT_NAME =
    process.env.CI_ENVIRONMENT_NAME as CI_ENVIRONMENT_NAMES ||
    'eon-hems-dev'

// prettier-ignore
type CI_ENVIRONMENT_TIERS =
    'development' |
    'staging' |
    'production';

export const CI_ENVIRONMENT_TIER: CI_ENVIRONMENT_TIERS = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
        case 'eon-hems-feature-1':
        case 'eon-hems-feature-2':
            return 'development';
        case 'eon-hems-qa':
        case 'eon-hems-qa-2':
            return 'staging';
        case 'eon-hems-prod':
        case 'eon-hems-prod-2':
            return 'production';
        default:
            return 'development';
    }
})();

export const ADMIN_PORTAL_UNLEASH_URL =
    'https://git.eon-cds.de/api/v4/feature_flags/unleash/521';

export const ADMIN_PORTAL_UNLEASH_CLIENT_KEY = 'xih-5nhQvJ_abAVChH17';

export const API_URL_DEFAULT: string = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
            return 'https://admin.api.dev.eonhome.eu';
        case 'eon-hems-feature-1':
            return 'https://admin.api.feature-one.dev.eonhome.eu';
        case 'eon-hems-feature-2':
            return 'https://admin.api.feature-two.dev.eonhome.eu';
        case 'eon-hems-qa':
            return 'https://admin.api.qa.eonhome.eu';
        case 'eon-hems-qa-1':
            return 'https://admin.api.feature-one.qa.eonhome.eu';
        case 'eon-hems-qa-2':
            return 'https://admin.api.feature-two.qa.eonhome.eu';
        case 'eon-hems-prod':
            return 'https://admin.api.prod.eonhome.eu';
        case 'eon-hems-prod-2':
            return 'https://admin.api.prod.eonhome.eu';
        default:
            return 'https://admin.api.dev.eonhome.eu';
    }
})();

export const APP_URL = window.location.origin;

export const DASHBOARD_API_URL_DEFAULT: string = (() => {
    switch (CI_ENVIRONMENT_TIER) {
        case 'development':
            return 'https://dashboard.api.dev.eonhome.eu';
        case 'staging':
            return 'https://dashboard.api.qa.eonhome.eu';
        case 'production':
            return 'https://dashboard.api.prod.eonhome.eu';
        default:
            return 'https://dashboard.api.dev.eonhome.eu';
    }
})();

export const HEMS_USER_FEATURE_GROUP: string = (() => {
    switch (CI_ENVIRONMENT_TIER) {
        case 'development':
            return 'dcd29f30-2676-11ec-acba-e70b58b3b7fa';
        case 'staging':
            return 'f4c11730-f17a-11e9-aa57-b7a4e34eb78d';
        case 'production':
            return '0eb07f40-25e1-11ec-9a96-ef95bf1ca4ef';
        default:
            return 'dcd29f30-2676-11ec-acba-e70b58b3b7fa';
    }
})();

export const LOGIN_URL = `${window.location.origin}/login`;

export const WEB_SOCKET_URL: string = (() => {
    switch (CI_ENVIRONMENT_NAME) {
        case 'eon-hems-dev':
            return 'wss://stream.dev.eonhome.eu';
        case 'eon-hems-feature-1':
            return 'wss://stream.feature-one.dev.eonhome.eu';
        case 'eon-hems-feature-2':
            return 'wss://stream.feature-two.dev.eonhome.eu';
        case 'eon-hems-qa':
        case 'eon-hems-qa-1':
        case 'eon-hems-qa-2':
            return 'wss://stream.qa.eonhome.eu';
        case 'eon-hems-prod':
        case 'eon-hems-prod-2':
            return 'wss://stream.home.eon.com';
        default:
            return 'wss://stream.dev.eonhome.eu';
    }
})();
